import React from "react";
import Modal from "./Modal";

/**
 * CreateFamilyModal - Modal for creating a new product family
 */
const CreateFamilyModal = ({
    isOpen,
    onClose,
    onSubmit,
    newFamilyName,
    setNewFamilyName,
    saving,
    activeProjectId
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} contentStyle={{ minWidth: '400px' }}>
            <h2 style={{ color: 'var(--text-primary)', margin: '0 0 1rem 0', fontSize: '1.25rem' }}>Create Family</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem', fontSize: '0.9rem' }}>
                Initialize a new family. Linked rule configurations can reference it.
            </p>
            
            <form onSubmit={onSubmit} className="importer-form">
                <div>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: 600 }}>Family Name</label>
                    <input
                        className="input-field"
                        value={newFamilyName}
                        onChange={e => setNewFamilyName(e.target.value)}
                        required
                        placeholder="e.g. Truck_Chassis"
                        autoFocus
                    />
                </div>
                {activeProjectId && (
                    <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '0.5rem', fontStyle: 'italic' }}>
                        Note: This family will be automatically linked to the active project: {localStorage.getItem('activeProjectName') || 'Unknown'}
                    </p>
                )}
                <div className="modal-actions">
                    <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
                    <button type="submit" className="btn-primary" style={{ background: 'var(--text-primary)', color: 'var(--bg-primary)' }} disabled={saving}>
                        {saving ? 'Creating...' : 'Create'}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default CreateFamilyModal;
